import script from "./MainwaveView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwaveView.vue?vue&type=script&setup=true&lang=js"

import "./MainwaveView.vue?vue&type=style&index=0&id=58e8dea6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e8dea6"]])

export default __exports__